import { createFeatureSelector, createSelector } from '@ngrx/store';

import { NewsfeedResult } from './newsfeed-results.models';
import { NEWSFEED_RESULTS_FEATURE_KEY, newsfeedResultsAdapter, NewsfeedResultsState } from './newsfeed-results.reducer';

const { selectAll } = newsfeedResultsAdapter.getSelectors();

export const getState = createFeatureSelector<NewsfeedResultsState>(NEWSFEED_RESULTS_FEATURE_KEY);
export const getSource = createSelector(getState, (state: NewsfeedResultsState) => state.source);
export const getIsLoaded = createSelector(getState, (state: NewsfeedResultsState) => state.loaded);
export const getIsLoadingMore = createSelector(getState, (state: NewsfeedResultsState) => state.loadingMore);
export const getError = createSelector(getState, (state: NewsfeedResultsState) => state.error);
export const getResults = createSelector(getState, (state: NewsfeedResultsState) => selectAll(state));
export const getResultsCount = createSelector(getResults, (results: NewsfeedResult[]) => results.length);
export const getResultsTotalAmount = createSelector(getState, (state: NewsfeedResultsState) => state.totalAmount);
export const getNextCursor = createSelector(getState, (state: NewsfeedResultsState) => state.nextCursor);
export const getSeed = createSelector(getState, (state: NewsfeedResultsState) => state.seed);
